import React from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  Header,
  Image,
  Segment,
  Grid,
  List,
  Icon,
  Divider,
} from "semantic-ui-react";
import classes from "./FootersPages.module.css";

export default function AboutUs() {
  const { t } = useTranslation();

  return (
    <Container className={`${classes.aboutus}`} style={{ padding: "3em 0em" }}>
      <Segment basic textAlign="center">
        <Header as="h1" style={{ fontSize: "2.5em" }}>
          {t("about_us.header")}
        </Header>
        <p style={{ fontSize: "1.33em" }}>{t("about_us.description")}</p>
      </Segment>

      <Divider section />

      <Segment basic>
        <Grid stackable columns={2} verticalAlign="middle">
          <Grid.Column width={8}>
            <Image
              src="https://firebasestorage.googleapis.com/v0/b/storiagl.appspot.com/o/PublicImages%2Fabout_us_why.jpg?alt=media&token=34e4db2f-3c16-4b40-a304-e929d9e3e3ba"
              rounded
              alt="Why"
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <Header as="h2" style={{ fontSize: "2em" }}>
              {t("about_us.why")}
            </Header>
            <p style={{ fontSize: "1.2em" }}>{t("about_us.why_desc_1")}</p>
            <p style={{ fontSize: "1.2em" }}>{t("about_us.why_desc_2")}</p>
            <p style={{ fontSize: "1.2em" }}>{t("about_us.why_desc_3")}</p>
            <p style={{ fontSize: "1.2em" }}>{t("about_us.why_desc_4")}</p>
            <p style={{ fontSize: "1.2em" }}>{t("about_us.why_desc_5")}</p>
          </Grid.Column>
        </Grid>
      </Segment>

      <Divider section />

      <Segment basic>
        <Grid stackable columns={2} verticalAlign="middle">
          <Grid.Column width={8}>
            <Header as="h2" style={{ fontSize: "2em" }}>
              {t("about_us.mission")}
            </Header>
            <p style={{ fontSize: "1.2em" }}>{t("about_us.mission_desc_1")}</p>
            <p style={{ fontSize: "1.2em" }}>{t("about_us.mission_desc_2")}</p>
          </Grid.Column>
          <Grid.Column width={8}>
            <Image
              src="https://firebasestorage.googleapis.com/v0/b/storiagl.appspot.com/o/PublicImages%2Ftable.png?alt=media&token=ff7d1f10-2310-43f7-8e7c-7fb9d538b1d5"
              rounded
              alt="Mission"
            />
          </Grid.Column>
        </Grid>
      </Segment>

      <Divider section />

      <Segment basic>
        <Header as="h2" style={{ fontSize: "2em" }} textAlign="center">
          {t("about_us.team")}
        </Header>
        <Grid stackable columns={3} verticalAlign="middle">
          <Grid.Column
            key={1}
            textAlign="center"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Image
              src={`https://firebasestorage.googleapis.com/v0/b/storiagl.appspot.com/o/PublicImages%2FSimon.jpg?alt=media&token=3ce0484b-35d7-402f-be69-4d585be82488`}
              circular
              size="small"
              alt={"Simon BIFFE"}
              style={{ marginTop: "10px" }}
            />
            <Header as="h3" style={{ marginTop: "10px" }}>
              {"Simon BIFFE"}
            </Header>
            <a
              href="https://www.linkedin.com/in/simon-biffe-b93a58225/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0e76a8" }} // Official color of LinkedIn
            >
              <Icon name="linkedin" size="large" />
            </a>
            <p style={{ marginTop: "5px" }}>  
              {t("about_us.project_coordinator")} <br />  
              {t("about_us.developer")} <br />  
              {t("about_us.narrative_lead")}  
            </p>
          </Grid.Column>
          <Grid.Column
            key={2}
            textAlign="center"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Image
              src={`https://firebasestorage.googleapis.com/v0/b/storiagl.appspot.com/o/PublicImages%2FPaul.jpg?alt=media&token=c182ffab-01b0-44cf-b032-4a9988fd29d1`}
              circular
              size="small"
              alt={"Paul WACQUET"}
              style={{ marginTop: "10px" }}
            />
            <Header as="h3" style={{ marginTop: "10px" }}>
              {"Paul WACQUET"}
            </Header>
            <a
              href="https://www.linkedin.com/in/paul-wacquet-872181230"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0e76a8" }} // Official color of LinkedIn
            >
              <Icon name="linkedin" size="large" />
            </a>
            <p style={{ marginTop: "5px" }}>  
              {t("about_us.backend_developer")} <br />  
              <br />  
              <br /> 
            </p>
          </Grid.Column>
          <Grid.Column
            key={3}
            textAlign="center"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Image
              src={`https://firebasestorage.googleapis.com/v0/b/storiagl.appspot.com/o/PublicImages%2FMarin.jpg?alt=media&token=97a68e3b-6d60-4f35-beb4-8379e98aedfc`}
              circular
              size="small"
              alt={"Marin LUET"}
              style={{ marginTop: "10px" }}
            />
            <Header as="h3" style={{ marginTop: "10px" }}>
              {"Marin LUET"}
            </Header>
            <a
              href="https://www.linkedin.com/in/marin-luet/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0e76a8" }} // Official color of LinkedIn
            >
              <Icon name="linkedin" size="large" />
            </a>
            <p style={{ marginTop: "5px" }}>
              {t("about_us.api_lead")} <br />
              {t("about_us.fullstack_developer")} <br />
              <br />
            </p>
          </Grid.Column>
        </Grid>
      </Segment>

      <Divider section />

      <Segment basic textAlign="center">
        <Header as="h2" style={{ fontSize: "2em" }}>
          {t("about_us.header")}
        </Header>
        <List horizontal divided link size="large">
          <List.Item as="a" href="mailto:contact@fablia.fr">
            {t("about_us.email_us")}
          </List.Item>
            <List.Item
                as="a"
                href="https://www.facebook.com/people/Fablia/61574400869813/"
            >
                Facebook
            </List.Item>
          <List.Item
            as="a"
            href="https://www.instagram.com/fablia_fr"
          >
            Instagram
          </List.Item>
        </List>
      </Segment>

      <Divider section />
    </Container>
  );
}
